import {
  useActivityWorkflowActions,
  useCurrentActivities,
  useCurrentActivity,
  useLatestBatch,
  useNextEventKind,
  useCurrentAsset,
} from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import ActivityAttributeEditorForStatus from "../ActivityAttributeEditorForStatus"
import { ActivityEditProps, ActivityManageScreen } from "./screens"
import { getAttributeValuesForEventKind } from "./attributes"
import ActivityScreenWrapper from "./ActivityScreenWrapper"
import ActivityLoading from "./ActivityLoading"
interface ActivityEditProgressProps extends ActivityEditProps {}

const ActivityEditProgress = ({ onScreenChange, onBack, onChange }: ActivityEditProgressProps) => {
  const activity = useCurrentActivity()
  const activities = useCurrentActivities()
  const nextEventKind = useNextEventKind()
  const asset = useCurrentAsset()
  const { needToRefresh } = useActivityWorkflowActions()
  const latestBatch = useLatestBatch()
  if (!activity || !activities) {
    return <ActivityLoading />
  }

  return (
    <ActivityScreenWrapper>
      <ActivityAttributeEditorForStatus
        asset={asset}
        order={undefined}
        activity={activity}
        activities={activities}
        eventKind={nextEventKind}
        existingValues={getAttributeValuesForEventKind(activity, nextEventKind)}
        isStatusProgression={true}
        onSuccess={() => {
          needToRefresh()
          onChange()
        }}
        onCancel={onBack}
        onBack={onBack}
        onNavigateToBatchCreation={() => onScreenChange(ActivityManageScreen.CreateBatch)}
        newlyCreatedBatch={latestBatch}
      />
    </ActivityScreenWrapper>
  )
}

export default ActivityEditProgress
